import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {bl_applet_catalog_event_RowInterface} from '../../../../../models/dbschema/bl_applet_catalog_event.model';
import {Core2Config} from '../shared/core2Config';

@Injectable({providedIn: 'root'})
export class CatalogEventService extends BaseApiTemplateService<{ bl_applet_catalog_event: bl_applet_catalog_event_RowInterface }> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.PLATFORM_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'catalog-events';
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'catalog-events';
    this.httpClient = http;
  }
}
